import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const ROBINHOOD_API_URL = 'https://api.robinhood.com'
export const ROBINHOOD_URL = 'https://applink.robinhood.com/u/connect'
export const ROBINHOOD_REDIRECT_URL = 'https://www.exodus.com/m/robinhood'

export const ENABLED_ASSETS = {
  __proto__: null,
  btc_bitcoin: assets.bitcoin?.name,
  doge_dogecoin: assets.dogecoin?.name,
  eth_ethereum: assets.ethereum?.name,
  ltc_litecoin: assets.litecoin?.name,
  usdc_ethereum: assets.usdcoin?.name,
  usdc_solana: assets.usdcoin_solana?.name,
  xtz_tezos: assets.tezos?.name,
}

export const ENABLED_COUNTRIES = {
  __proto__: null,
  US: true,
}

export const DEFAULT_FIAT_PRECISION = 2
export const DEFAULT_CRYPTO_PRECISION = 8
export const DEFAULT_MAX = Number.MAX_SAFE_INTEGER
export const DEFAULT_MIN = 0
export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  bank_transfer: 'bank_transfer',
  buying_power: 'buying_power',
  debit_card: 'debit_card',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.buying_power,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.buying_power,
      type: PAYMENT_METHOD_TYPES.robinhood,
      // We enable buying_power only for now because we don't want Robinhood to compete
      // with other providers on bank and card methods. It makes Robinhood behave like a payment method in UI.
      countries: [{ id: 'US', enabled: true }],
      currencies: [{ id: 'USD', enabled: true }],
    }),
  ],
])
